export const carColors = {
        "Audi R8 LMS GT3": "rgb(151, 151, 151)",
        "Audi R8 LMS EVO II GT3": "rgba(163, 163, 163, 1)",
        "Mercedes-AMG GT3 2020": "rgb(56, 144, 144)",
        "Ford GT GT3": "rgba(43, 62, 172, 1)",
        "Ferrari 296 GT3": "rgb(176, 16, 48)",
        "McLaren MP4-12C GT3": "rgb(204, 112, 0)",
        "McLaren 720S GT3 EVO": "rgb(255, 135, 0)",
        "BMW M4 GT3": "rgb(0, 123, 174)",
        "BMW M4 G82 GT4 Evo": "rgba(160, 47, 191, 1)",
        "Lamborghini Huracán GT3 EVO": "rgba(189, 189, 34, 1)",
        "Porsche 911 GT3 R (992)": "#b08d57",
        "McLaren 570S GT4": "rgb(204, 112, 0)",
        "BMW M4 GT4": "rgb(0, 123, 174)",
        "BMW M4 GT3 EVO": "rgb(0, 90, 220)",
        "Porsche 718 Cayman GT4 Clubsport MR": "#b08d57",
        "Mercedes-AMG GT4": "rgb(56, 144, 144)",
        "Aston Martin Vantage GT4": "rgba(9, 130, 9, 1)",
        "Aston Martin Vantage GT3 EVO": "rgb(11, 94, 11)",
        "BMW M Hybrid V8": "rgb(0, 100, 180)",
        "Dallara P217": "rgba(19, 194, 28, 1)",
        "Hyundai Elantra N TCR": "rgb(0, 46, 106)",
        "Porsche 963 GTP": "rgb(0, 46, 106)",
        "Audi RS 3 LMS TCR": "rgb(151, 151, 151)",
        "Hyundai Veloster N TCR": "rgb(0, 165, 220)",
        "Honda Civic Type R TCR": "rgb(163, 0, 0)",
        "Cadillac V-Series.R GTP": "rgb(203, 165, 41)",
        "Ligier JS P320": "#4f72a8",
        "Toyota GR86": "#EB0A1E",
        "Acura ARX-06 GTP": "#af0aebff",
        "Acura NSX GT3 EVO 22": "#EB0A1E",
        "Global Mazda MX-5 Cup": "rgb(2, 86, 146)",
        "Ford Mustang FR500S": "rgb(0, 46, 106)",
        "Renault Clio": "rgba(24, 162, 24, 1)",
        "Porsche 911 RSR": "#b08d57",
        "Chevrolet Corvette C8.R GTE": "rgba(146, 146, 146, 1)",
        "BMW M8 GTE": "rgb(0, 123, 174)",
        "Ferrari 488 GTE": "rgb(176, 16, 48)",
        "Ford GTE": "rgb(48, 62, 137)",
        "Ford Mustang GT3": "rgb(0,0,205)",
        "Ford Mustang GT4": "rgba(13, 63, 213, 1)",
        "Chevrolet Corvette Z06 GT3.R": "#C329E7",
        "Super Formula SF23 - Toyota": "#EB0A1E",
        "NASCAR Cup Series Next Gen Chevrolet Camaro ZL1": "rgb(0, 123, 174)",
        "NASCAR Cup Series Next Gen Ford Mustang": "rgb(163, 0, 0)",
        "NASCAR Truck Chevrolet Silverado": "rgb(200, 150, 0)",
        "NASCAR Truck Toyota Tundra TRD Pro": "rgb(235, 10, 30)",
        "Ferrari 499P": "rgb(163, 0, 0)",
};
